import type {
  DaySchedule,
  SymbolCategory,
  TradingSymbol,
} from "@/types/tradingTool";

const WEEKDAY_HOURS: DaySchedule[] = [
  { day: "Monday", open: true, hours: "00:05 - 23:55" },
  { day: "Tuesday", open: true, hours: "00:05 - 23:55" },
  { day: "Wednesday", open: true, hours: "00:05 - 23:55" },
  { day: "Thursday", open: true, hours: "00:05 - 23:55" },
  { day: "Friday", open: true, hours: "00:05 - 23:55" },
  { day: "Saturday", open: false },
  { day: "Sunday", open: false },
];

export const SYMBOL_CATEGORIES: SymbolCategory[] = [
  "Forex",
  "Exotics",
  "Metals",
  "Cash",
  "Crypto",
  "Equities",
];

export const TRADING_SYMBOLS: TradingSymbol[] = [
  {
    id: "eur-usd",
    pair: "EUR-USD",
    category: "Forex",
    flagCode: "eu",
    contractSize: "100,000",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "jpy-usd",
    pair: "JPY-USD",
    category: "Forex",
    flagCode: "jp",
    contractSize: "100,000",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "cad-usd",
    pair: "CAD-USD",
    category: "Forex",
    flagCode: "ca",
    contractSize: "100,000",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "gbp-usd",
    pair: "GBP-USD",
    category: "Forex",
    flagCode: "gb",
    contractSize: "100,000",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "aud-usd",
    pair: "AUD-USD",
    category: "Forex",
    flagCode: "au",
    contractSize: "100,000",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "try-usd",
    pair: "TRY-USD",
    category: "Exotics",
    flagCode: "tr",
    contractSize: "100,000",
    margin: "2%",
    leverage: "1:50",
    leverageSwing: "1:20",
    commission: "4 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "cny-usd",
    pair: "CNY-USD",
    category: "Exotics",
    flagCode: "cn",
    contractSize: "100,000",
    margin: "2%",
    leverage: "1:50",
    leverageSwing: "1:20",
    commission: "4 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "xau-usd",
    pair: "XAU-USD",
    category: "Metals",
    flagCode: "us",
    contractSize: "100",
    margin: "1%",
    leverage: "1:100",
    leverageSwing: "1:30",
    commission: "3 USD/LOT",
    isOpen: true,
    closesAt: "12:16:25",
    schedule: WEEKDAY_HOURS,
  },
  {
    id: "btc-usd",
    pair: "BTC-USD",
    category: "Crypto",
    flagCode: "us",
    contractSize: "1",
    margin: "5%",
    leverage: "1:20",
    leverageSwing: "1:10",
    commission: "0.05%",
    isOpen: true,
    closesAt: "23:59:59",
    schedule: [
      { day: "Monday", open: true, hours: "00:00 - 23:59" },
      { day: "Tuesday", open: true, hours: "00:00 - 23:59" },
      { day: "Wednesday", open: true, hours: "00:00 - 23:59" },
      { day: "Thursday", open: true, hours: "00:00 - 23:59" },
      { day: "Friday", open: true, hours: "00:00 - 23:59" },
      { day: "Saturday", open: true, hours: "00:00 - 23:59" },
      { day: "Sunday", open: true, hours: "00:00 - 23:59" },
    ],
  },
  {
    id: "nas100",
    pair: "NAS100",
    category: "Equities",
    flagCode: "us",
    contractSize: "1",
    margin: "2%",
    leverage: "1:50",
    leverageSwing: "1:20",
    commission: "0 USD/LOT",
    isOpen: true,
    closesAt: "22:00:00",
    schedule: WEEKDAY_HOURS,
  },
];
